import log from '~/utils/log';
import type { RouteLocationNormalizedGeneric } from 'vue-router';

/**
 * Get the Shopware language ID for the current language based on useLanguage() composable.
 *
 * @returns The Shopware language ID or undefined if not found.
 */
export function useShopwareLanguageId(): string | undefined {
    const lang = useLanguage().lang.value;

    const langId: string | undefined = useRuntimeConfig()?.public?.shopware?.languageIds?.[lang];

    if (!langId) {
        log.warn(
            '[Warning][Shopware] Language ID not found for language:',
            lang,
            '\nFalling back to safe language "en"'
        );
        const fallbackLanguageId = useRuntimeConfig()?.public?.shopware?.languageIds?.['en'];
        if (!fallbackLanguageId) {
            log.warn('[Warning][Shopware] Fallback language ID not found for language:', 'en');
        }
        return fallbackLanguageId;
    }

    return langId;
}
